import {REPORT_INACTIVE_CLIENTS} from '/enum/records.enum';

export default {
  reportName: REPORT_INACTIVE_CLIENTS,
};
